import { useState, useEffect } from "react";
import { Container, Row, Col, Form, Nav, Tab, Button, Card, Table, Badge } from "react-bootstrap";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { FaFileUpload, FaSearch, FaUserTie, FaFileAlt, FaCamera, FaPrint } from 'react-icons/fa';
import { api } from '../axios/api';
import Swal from 'sweetalert2';

const Candidaturas = () => {
    const [key, setKey] = useState('candidatar');
    const [provincias, setProvincias] = useState([]);
    const [categorias, setCategorias] = useState([]);
    const [vagas, setVagas] = useState([]);
    
    // Estados para consulta e preview
    const [busca, setBusca] = useState("");
    const [resultadoConsulta, setResultadoConsulta] = useState(null);
    const [loadingBusca, setLoadingBusca] = useState(false);
    const [photoPreview, setPhotoPreview] = useState(null);

    const [formData, setFormData] = useState({
        nome: "",
        email: "",
        telefone: "",
        identificacao: "",
        nacionalidade: "Angolana",
        naturalidade: "",
        residencia: "",
        provincia_id: "",
        categoria_id: "",
        vaga_id: ""
    });

    const [files, setFiles] = useState({
        foto: null,
        cv: null,
        bi: null,
        certificado: null,
        carta_apresentacao: null
    });

    // 1. Carregar Províncias e Categorias
    useEffect(() => {
        const fetchData = async () => {
            try {
                const [resProv, resCat] = await Promise.all([
                    api.get('Provincia.php?action=listAll'),
                    api.get('Categoria.php?action=listAll')
                ]);
                setProvincias(resProv.data.data || []);
                setCategorias(resCat.data.data || []);
            } catch (err) {
                console.error("Erro ao carregar dados iniciais", err);
            }
        };
        fetchData();
    }, []);

    // 2. Filtro de Vagas dinâmico
    useEffect(() => {
        if (formData.provincia_id && formData.categoria_id) {
            const filterVagas = async () => {
                try {
                    const res = await api.get(`Vaga.php?action=filter&provincia_id=${formData.provincia_id}&categoria_id=${formData.categoria_id}`);
                    setVagas(res.data || []);
                } catch (err) {
                    console.error("Erro ao filtrar vagas", err);
                }
            };
            filterVagas();
        } else {
            setVagas([]);
        }
    }, [formData.provincia_id, formData.categoria_id]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleFileChange = (e) => {
        const { name, files: selectedFiles } = e.target;
        const file = selectedFiles[0];
        
        if (file) {
            setFiles(prev => ({ ...prev, [name]: file }));
            
            // Gerar Preview apenas para a foto
            if (name === 'foto') {
                const reader = new FileReader();
                reader.onloadend = () => setPhotoPreview(reader.result);
                reader.readAsDataURL(file);
            }
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        Swal.fire({
            title: 'Processando...',
            text: 'Enviando sua candidatura e documentos...',
            allowOutsideClick: false,
            didOpen: () => Swal.showLoading()
        });

        const data = new FormData();
        data.append("action", "create");
        Object.keys(formData).forEach(k => data.append(k, formData[k]));
        Object.keys(files).forEach(k => {
            if (files[k]) data.append(k, files[k]);
        });

        try {
            const res = await api.post('Recrutamento.php', data);
            
            if (res.data.success) {
                const idInscricao = res.data.data.id;
                const protocolo = res.data.data.protocolo;

                Swal.fire({
                    icon: 'success',
                    title: 'Inscrição Concluída!',
                    html: `Sua candidatura foi enviada.<br><b>Protocolo: ${protocolo}</b>`,
                    confirmButtonColor: '#2c2219'
                })
            } else {
                Swal.fire({
                    icon: 'warning',
                    title: 'Atenção',
                    text: res.data.message || 'Erro ao processar.',
                    confirmButtonColor: '#c5a47e'
                });
            }
        } catch (error) {
            Swal.fire({ icon: 'error', title: 'Erro Crítico', text: 'Falha na comunicação com o servidor.' });
        }
    };

    const handleConsultar = async (e) => {
        e.preventDefault();
        if (!busca) return;

        setLoadingBusca(true);
        try {
            const res = await api.get(`Recrutamento.php?action=filter&keyword=${busca}`);
            if (res.data.success && res.data.data.length > 0) {
                setResultadoConsulta(res.data.data[0]);
            } else {
                setResultadoConsulta(null);
                Swal.fire({ icon: 'info', title: 'Não encontrado', text: 'Nenhuma candidatura vinculada a este BI/Código.' });
            }
        } catch (err) {
            Swal.fire({ icon: 'error', title: 'Erro', text: 'Erro ao consultar banco de dados.' });
        } finally {
            setLoadingBusca(false);
        }
    };

    return (
        <>
            <Navbar />
            <main style={{ backgroundColor: "#fdfcf9", minHeight: "80vh" }}>
                <section className="py-5" style={{ backgroundColor: "#2c2219", color: "#f4f1ea" }}>
                    <Container className="text-center">
                        <h6 className="text-uppercase fw-bold mb-2" style={{ color: "#c5a47e", letterSpacing: "3px" }}>Carreiras</h6>
                        <h1 className="display-4 fw-bold" style={{ fontFamily: "'Playfair Display', serif" }}>Recrutamento & Seleção</h1>
                    </Container>
                </section>

                <Container className="py-5">
                    <Tab.Container activeKey={key} onSelect={(k) => setKey(k)}>
                        <Row className="justify-content-center">
                            <Col lg={10}>
                                <Nav className="justify-content-center mb-5 custom-tabs">
                                    <Nav.Item>
                                        <Nav.Link eventKey="candidatar" className="px-4 py-3 fw-bold text-uppercase">
                                            <FaUserTie className="me-2" /> Nova Candidatura
                                        </Nav.Link>
                                    </Nav.Item>
                                    <Nav.Item>
                                        <Nav.Link eventKey="consultar" className="px-4 py-3 fw-bold text-uppercase">
                                            <FaSearch className="me-2" /> Consultar Estado
                                        </Nav.Link>
                                    </Nav.Item>
                                </Nav>

                                <Tab.Content>
                                    <Tab.Pane eventKey="candidatar">
                                        <Card className="border-0 shadow-sm p-4 p-md-5 rounded-0">
                                            <Form onSubmit={handleSubmit}>
                                                <h5 className="border-bottom pb-2 mb-4 text-uppercase small fw-bold" style={{ color: "#c5a47e" }}>Dados Pessoais</h5>
                                                <Row>
                                                    <Col md={8}>
                                                        <Row>
                                                            <Col md={12} className="mb-3">
                                                                <Form.Label className="small fw-bold">Nome Completo</Form.Label>
                                                                <Form.Control name="nome" value={formData.nome} onChange={handleInputChange} className="rounded-0 bg-light" type="text" required />
                                                            </Col>
                                                            <Col md={6} className="mb-3">
                                                                <Form.Label className="small fw-bold">E-mail</Form.Label>
                                                                <Form.Control name="email" value={formData.email} onChange={handleInputChange} className="rounded-0 bg-light" type="email" required />
                                                            </Col>
                                                            <Col md={6} className="mb-3">
                                                                <Form.Label className="small fw-bold">Telefone</Form.Label>
                                                                <Form.Control name="telefone" value={formData.telefone} onChange={handleInputChange} className="rounded-0 bg-light" type="tel" required />
                                                            </Col>
                                                        </Row>
                                                    </Col>
                                                    <Col md={4} className="mb-3 text-center">
                                                        <Form.Label className="small fw-bold d-block">Foto Tipo Passe</Form.Label>
                                                        <div className="border bg-light d-flex align-items-center justify-content-center overflow-hidden mb-2" 
                                                             style={{ height: "150px", width: "130px", margin: "0 auto", border: "2px dashed #c5a47e" }}>
                                                            {photoPreview ? (
                                                                <img src={photoPreview} alt="Preview" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                                                            ) : (
                                                                <FaCamera size={30} className="text-muted" />
                                                            )}
                                                        </div>
                                                        <Form.Control name="foto" onChange={handleFileChange} type="file" accept="image/*" className="small" required />
                                                    </Col>
                                                </Row>

                                                <Row>
                                                    <Col md={6} className="mb-3">
                                                        <Form.Label className="small fw-bold">Nº Identificação (BI)</Form.Label>
                                                        <Form.Control name="identificacao" value={formData.identificacao} onChange={handleInputChange} className="rounded-0 bg-light" type="text" required />
                                                    </Col>
                                                    <Col md={6} className="mb-3">
                                                        <Form.Label className="small fw-bold">Nacionalidade</Form.Label>
                                                        <Form.Control name="nacionalidade" value={formData.nacionalidade} onChange={handleInputChange} className="rounded-0 bg-light" type="text" required />
                                                    </Col>
                                                    <Col md={6} className="mb-3">
                                                        <Form.Label className="small fw-bold">Naturalidade</Form.Label>
                                                        <Form.Control name="naturalidade" value={formData.naturalidade} onChange={handleInputChange} className="rounded-0 bg-light" type="text" required />
                                                    </Col>
                                                    <Col md={6} className="mb-3">
                                                        <Form.Label className="small fw-bold">Residência</Form.Label>
                                                        <Form.Control name="residencia" value={formData.residencia} onChange={handleInputChange} className="rounded-0 bg-light" type="text" required />
                                                    </Col>
                                                    
                                                    <Col md={4} className="mb-3">
                                                        <Form.Label className="small fw-bold">Província</Form.Label>
                                                        <Form.Select name="provincia_id" onChange={handleInputChange} className="rounded-0 bg-light" required>
                                                            <option value="">Selecione...</option>
                                                            {provincias.map(p => <option key={p.id} value={p.id}>{p.nome}</option>)}
                                                        </Form.Select>
                                                    </Col>
                                                    <Col md={4} className="mb-3">
                                                        <Form.Label className="small fw-bold">Categoria</Form.Label>
                                                        <Form.Select name="categoria_id" onChange={handleInputChange} className="rounded-0 bg-light" required>
                                                            <option value="">Selecione...</option>
                                                            {categorias.map(c => <option key={c.id} value={c.id}>{c.nome}</option>)}
                                                        </Form.Select>
                                                    </Col>
                                                    <Col md={4} className="mb-3">
                                                        <Form.Label className="small fw-bold">Vaga Disponível</Form.Label>
                                                        <Form.Select name="vaga_id" onChange={handleInputChange} className="rounded-0 bg-light" required disabled={vagas.length === 0}>
                                                            <option value="">{vagas.length > 0 ? "Selecione a vaga" : "Nenhuma vaga encontrada"}</option>
                                                            {vagas.map(v => <option key={v.id} value={v.id}>{v.categoria_nome} ({v.numero_vagas})</option>)}
                                                        </Form.Select>
                                                    </Col>
                                                </Row>

                                                <h5 className="border-bottom pb-2 mt-4 mb-4 text-uppercase small fw-bold" style={{ color: "#c5a47e" }}>Documentação (PDF)</h5>
                                                <Row>
                                                    {['cv', 'bi', 'certificado', 'carta_apresentacao'].map((doc) => (
                                                        <Col md={6} className="mb-3" key={doc}>
                                                            <Form.Label className="small fw-bold text-uppercase">{doc.replace('_', ' ')}</Form.Label>
                                                            <Form.Control name={doc} onChange={handleFileChange} type="file" accept=".pdf" required />
                                                        </Col>
                                                    ))}
                                                </Row>

                                                <Button type="submit" className="w-100 rounded-0 py-3 mt-3 fw-bold border-0 btn-dark-brown">
                                                    SUBMETER CANDIDATURA
                                                </Button>
                                            </Form>
                                        </Card>
                                    </Tab.Pane>

                                    <Tab.Pane eventKey="consultar">
                                        <Card className="border-0 shadow-sm p-4 p-md-5 rounded-0">
                                            <h5 className="border-bottom pb-2 mb-4 text-uppercase small fw-bold" style={{ color: "#c5a47e" }}>Consultar Estado</h5>
                                            <Form onSubmit={handleConsultar} className="mb-4">
                                                <Row className="align-items-end">
                                                    <Col md={9}>
                                                        <Form.Label className="small fw-bold">Nº do BI ou Protocolo</Form.Label>
                                                        <Form.Control 
                                                            type="text" 
                                                            className="rounded-0 bg-light" 
                                                            placeholder="Digite aqui..." 
                                                            value={busca}
                                                            onChange={(e) => setBusca(e.target.value)}
                                                            required 
                                                        />
                                                    </Col>
                                                    <Col md={3}>
                                                        <Button type="submit" className="w-100 rounded-0 border-0 btn-dark-brown" style={{ height: "38px" }} disabled={loadingBusca}>
                                                            {loadingBusca ? "Buscando..." : <><FaSearch /> Pesquisar</>}
                                                        </Button>
                                                    </Col>
                                                </Row>
                                            </Form>

                                            {resultadoConsulta && (
                                                <div className="mt-4 animate__animated animate__fadeIn">
                                                    <Table bordered hover responsive className="small">
                                                        <thead className="bg-light text-uppercase">
                                                            <tr>
                                                                <th>Candidato</th>
                                                                <th>Vaga</th>
                                                                <th>Protocolo</th>
                                                                <th>Estado</th>
                                                                <th>Ação</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr>
                                                                <td>{resultadoConsulta.nome}</td>
                                                                <td>{resultadoConsulta.categoria_nome}</td>
                                                                <td><code>{resultadoConsulta.numero_inscricao}</code></td>
                                                                <td>
                                                                    <Badge bg={resultadoConsulta.status === 'Pendente' ? 'warning' : 'success'}>
                                                                        {resultadoConsulta.status}
                                                                    </Badge>
                                                                </td>
                                                                <td>
                                                                    <Button size="sm" variant="outline-dark" className="rounded-0" 
                                                                        onClick={() => window.open(`${api.defaults.baseURL.replace('/routes', '')}/docs/Ficha.php?id=${resultadoConsulta.id}`, '_blank')}>
                                                                        <FaPrint />
                                                                    </Button>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </Table>
                                                </div>
                                            )}
                                        </Card>
                                    </Tab.Pane>
                                </Tab.Content>
                            </Col>
                        </Row>
                    </Tab.Container>
                </Container>
            </main>
            <Footer />
            <style>{`
                .custom-tabs .nav-link { color: #2c2219; border: none; border-bottom: 2px solid transparent; transition: 0.3s; }
                .custom-tabs .nav-link.active { color: #c5a47e !important; border-bottom: 2px solid #c5a47e !important; background: none !important; }
                .btn-dark-brown { background-color: #2c2219; color: #fff; transition: 0.3s; }
                .btn-dark-brown:hover { background-color: #c5a47e; color: #2c2219; }
            `}</style>
        </>
    );
};

export default Candidaturas;